export default __webpack_public_path__ + "static/media/photo_bg_sm.1c616efb.jpg";